/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left2" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right2" /></svg></button>';

	if($('.recruit-slide01').length) {
		for(let i = 0; i < $('.recruit-slide01 .ff_Raleway span').length; i++) {
			$('.recruit-slide01 .ff_Raleway span').eq(i).text((i + 1));
		}
		$('.recruit-slide01').slick({
			infinite: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 4000,
			slidesToShow: 2,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			dots: false,
			loop: true,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					dots: true,

				}
			}]
		});
	}
	if($('.recruit-slide02').length) {
		$('.recruit-slide02').slick({
			infinite: true,
			speed: 1000,
			autoplay: true,
			autoplaySpeed: 4000,
			slidesToShow: 2,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			dots: false,
			loop: true,
			responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,

				}
			}]
		});
	}

})(window.jQuery, window.FUNCTIONS);
